import { ConfirmDialog } from '@gogame/components';
import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import { moveToTestBusinessPartner } from 'scenes/BusinessPartners/sources/businessPartners';

import { archive } from '../queryKeyFactory';

export const useMoveToTestBusinessPartner = () => {
  const showModal = useScreenModalV2(ConfirmDialog);
  const moveToTestMutation = useMutation(archive(), moveToTestBusinessPartner, {
    successMessage: (_data) => {
      return `Business Partner moved to test`;
    },
  });

  const handleAction = async ({ id, name }) => {
    await showModal({
      title: `Move to test Business Partner?`,
      confirmActionLabel: 'Move to test',
      bodyText: `«${name}»`,
    });

    await moveToTestMutation.mutateAsync({ id });
  };
  return [handleAction, moveToTestMutation];
};
